export const CLIENT_NAME = "hornbach";
export const CLIENT_DISPLAY_NAME = "Hornbach";
export const MODAL_CONFIRM_BUTTON_LABEL = "übernehmen";
export const BASE_ASSET_URL = ` https://esr.fe-bis.de/at/${CLIENT_NAME}/`;
export const PLZ_VALIDATION = (plz : string) => plz.length == 4;
export const FOERDERUNG = false;
